// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
// class
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { SeedCropLossLandingFilterVM } from '../../../../models/SeedCropLoss/SeedCropLossLandingFilterVM';
import { OTIOrderLandingFilterVM } from '../../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../../services/oti/oti.service';

// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { SeedCropLossService } from '../../../../services/seed/seed-crop-loss/seed-crop-loss.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-seed-crop-loss-landing',
  templateUrl: './seed-crop-loss-landing.component.html',
  styleUrls: ['./seed-crop-loss-landing.component.scss']
})
export class SeedCropLossLandingComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
  @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
  @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;
  returnRequestDraftColumns: string[] = [];
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  returnRequestColumns: string[] = [];
  draftRequestDataSource: MatTableDataSource<any>;
  returnRequestDataSource: MatTableDataSource<any>;
  selectedTabIndex = 0;
  masterConstants = MasterConstants;
  subscription = new Subscription();
  filterOptionsData: Array<FilterOption>;
  filter: SeedCropLossLandingFilterVM = new SeedCropLossLandingFilterVM();
  returnRequestList: any = [];
  returnRequestDraftList: any = [];
  bannerMessage = '';
  draftSeedDataSource: MatTableDataSource<any>;
  seedDataSource: MatTableDataSource<any>;
  validateEvolveData: any;
  isEvolveAccountRestriction = false;
  userMenuAccessList: any;
  readOnlyAccess = false;
  isApprovalAccess = false;
  createRequestAccess = false;
  tabNode = false;
  isSubscriptionAccess = false;
  // effectiveConfigData: any;
  // isShowCreateNewRequestByConfigData = true;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    private seedCropLossService: SeedCropLossService,
    private datePipe: DatePipe,
    public excelService: ExcelService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private otiService: OtiService
  ) { }

  ngOnInit(): void {
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_REPLANT) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_REPLANT_APPROVAL);
    this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.SEED_REPLANT_APPROVAL);

    this.seedCropLossService.isApproverUser = false;
    this.fetchPageInitialApiData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();
  }

  fetchPageInitialApiData() {
    this.loaderService.setLoaderStatus(true);

    const forkJoinApIs = [];
    forkJoinApIs.push(this.seedCropLossService.getLandingBannerMessage());
    forkJoinApIs.push(this.seedCropLossService.getLandingGridData(this.filter));
    // forkJoinApIs.push(this.seedCropLossService.getEffectiveConfigData());
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      this.bannerMessage = result[0].message;
      this.setGridData(result[1]);
      // this.effectiveConfigData = result[2];
      // this.checkAndSetShowCreateNewRequestByConfigData();
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Number', key: 'accountnumber', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountname', controlType: ControlType.Text },
      { label: 'Request Date', key: 'requestdaterange', controlType: ControlType.DateRange },
      { label: 'Request Number', key: 'requestId', controlType: ControlType.Text },
      { label: 'Product Name', key: 'productname', controlType: ControlType.Text },
      { label: 'Item Number', key: 'productnumber', controlType: ControlType.Text },
      { label: 'Grower Name', key: 'growername', controlType: ControlType.Text },
      { label: 'Grower GMK', key: 'growergmk', controlType: ControlType.Integer },
      { label: 'Customer PO', key: 'customerPO', controlType: ControlType.Text },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
    ];

    this.returnRequestDraftColumns = ['webOrderNumber', 'custPONumber', 'accountName', 'accountNumber', 'draftDate', 'cropLossProducts', 'units', 'deleteRequest'];
    this.returnRequestColumns = ['webOrderNumber', 'custPONumber', 'accountName', 'accountNumber', 'requestDate', 'cropLossProducts', 'units', 'status', 'viewOrder'];
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      accountnumber: null,
      accountname: null,
      requestdaterange: null,
      requestId: null,
      productname: null,
      productnumber: null,
      growername: null,
      growergmk: null,
      customerPO: null,
      status: null
    };
  }
  // Set Drop down values for filter
  setDropDownValues() {
    if (MasterConstants.SEED_CROPLOSS_STATUS_LIST) {
      this.filterOptionsData.find(x => x.key == 'status').controlData = MasterConstants.SEED_CROPLOSS_STATUS_LIST;
    }
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 250;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Create a new Request (navigate to request entry screen)
  createNewRequest() {
    this.router.navigate(['/crop-loss-request-entry/']);
  }

  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedCropLossService.getLandingGridData(this.filter).subscribe((result: any[]) => {
      this.setGridData(result);

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  setGridData(result: any) {
    // Active tab variables.
    this.returnRequestList = result.filter(x => x.status.toUpperCase() !== 'PENDING');
    this.returnRequestDataSource = new MatTableDataSource(this.returnRequestList);
    this.returnRequestDataSource.paginator = this.returnRequestPaginator;
    this.returnRequestDataSource.paginator.firstPage();
    this.returnRequestDataSource.sort = this.returnRequestSort;

    // Draft tab variables.
    this.returnRequestDraftList = result.filter(x => x.status.toUpperCase() === 'PENDING');
    this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
    this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
    this.draftRequestDataSource.paginator.firstPage();
    this.draftRequestDataSource.sort = this.returnRequestDraftSort;
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  navigateCropLossRequestDetail(obj: any) {
    this.loaderService.setLoaderStatus(true);
    this.seedCropLossService.setRequestHeaderId(obj.requestId);
    this.router.navigate(['/crop-loss-request-entry', obj.requestId, 0]);
    this.loaderService.setLoaderStatus(false);
  }

  // Delete draft request
  deletecropLossdraftrequest(cropLossRequest: any) {
    if (cropLossRequest) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.seedCropLossService.deleteDraftRequest(cropLossRequest.requestId).subscribe(result => {
            if (result) {
              this.toastrService.success('Draft order deleted successfully.');
              this.getGridData();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      });
    }
  }

  public export() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.seedCropLossService.getLandingExportData(this.filter).subscribe((result: any[]) => {
      this.loaderService.setLoaderStatus(true);
      if (this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length > 0) {
        let cropLossExportDataList: any = [];
        // Active tab variables.
        cropLossExportDataList = result.filter(x => x.requestStatus.toUpperCase() !== 'PENDING');
        var exportData = [];
        cropLossExportDataList.forEach(x => {
          exportData.push({
            'ReplantRequestID': x.webOrderNumber,
            'Transaction Type': x.transactionType,
            'Ship To Account': x.shipToAccount,
            'Ship To Name': x.shipToName,
            'Ship To Address': x.shipToAddress,
            'Ship To City': x.shipToCity,
            'Ship To State': x.shipToState,
            'Ship To Zip': x.shipToZipCode,
            'Grower Business Name': x.producerBusinessName,
            'Grower First Name': x.producerFirstName,
            'Grower Middle Name': x.producerMiddleName,
            'Grower Last Name': x.producerLastName,
            'Grower Address1': x.producerAddress1,
            'Grower Address2': x.producerAddress2,
            'Grower City': x.producerCity,
            'Grower State': x.producerState,
            'Grower Zip': x.producerZipCode,
            'Traite License': x.traiteLicense,
            'GrowerMasterKey': x.gmk,
            'RequestType': x.requestType,
            'AccountToCreditAccountNumber': x.creditToAccountNumber,
            'AccountToCreditAccountName': x.creditToAccountName,
            'AccountToCreditCity': x.creditToAccountCity,
            'AccountToCreditState': x.creditToAccountState,
            'AccountToCreditZip': x.creditToAccountZipCode,
            'SubmittedBy': x.createUser,
            'SubmittedDate': this.datePipe.transform(x.createTimeStamp, MasterConstants.DATE_MMDDYYYY),
            'Approved': x.approved,
            'ApprovedBy': x.userApproved,
            'ApprovedDate': x.approvedDate,
            'ProductType': x.productType == true ? 'Failed' : 'Replant',
            'CompanyNumber': x.companyNumber,
            'OriginalOrderNumber': x.orderNumber,
            'OriginalOrderType': x.orderType,
            'LineNumber': x.lineNumber,
            'ItemNumber': x.itemNumber,
            'Item': x.item,
            'SeedSize': x.seedSize,
            'LotNumber': x.lotNumber,
            'PricePerUnit': x.pricePerUnit,
            'Units': x.units,
            'UnitsFailed': x.unitsFailed,
            'Units Replant Credited': '',
            'InvoiceNumber': x.purchaseOrder,
            'ProductLine': x.productLine,
            'Request Date': this.datePipe.transform(x.requestDate, MasterConstants.DATE_MMDDYYYY),
            'OriginalInvoiceNumberToGrower': x.originalInvoiceNumberToGrower,
            'Plant Date': this.datePipe.transform(x.plantDate, MasterConstants.DATE_MMDDYYYY),
            'ProblemDescription': x.problemDescription,
            'Approver Notes': x.approverNotes
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'ActiveCropLossRequests');
      }
      else if (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length > 0) {
        let draftExportCropLossDataList: any = [];
        // Draft tab variables.
        draftExportCropLossDataList = result.filter(x => x.requestStatus.toUpperCase() === 'PENDING');
        var exportData = [];
        this.loaderService.setLoaderStatus(true);
        draftExportCropLossDataList.forEach(x => {
          exportData.push({
            'ReplantRequestID': x.webOrderNumber,
            'Transaction Type': x.transactionType,
            'Ship To Account': x.shipToAccount,
            'Ship To Name': x.shipToName,
            'Ship To Address': x.shipToAddress,
            'Ship To City': x.shipToCity,
            'Ship To State': x.shipToState,
            'Ship To Zip': x.shipToZipCode,
            'Grower Business Name': x.producerBusinessName,
            'Grower First Name': x.producerFirstName,
            'Grower Middle Name': x.producerMiddleName,
            'Grower Last Name': x.producerLastName,
            'Grower Address1': x.producerAddress1,
            'Grower Address2': x.producerAddress2,
            'Grower City': x.producerCity,
            'Grower State': x.producerState,
            'Grower Zip': x.producerZipCode,
            'Traite License': x.traiteLicense,
            'GrowerMasterKey': x.gmk,
            'RequestType': x.requestType,
            'AccountToCreditAccountNumber': x.creditToAccountNumber,
            'AccountToCreditAccountName': x.creditToAccountName,
            'AccountToCreditCity': x.creditToAccountCity,
            'AccountToCreditState': x.creditToAccountState,
            'AccountToCreditZip': x.creditToAccountZipCode,
            'SubmittedBy': x.createUser,
            'SubmittedDate': this.datePipe.transform(x.createTimeStamp, MasterConstants.DATE_MMDDYYYY),
            'Approved': x.approved,
            'ApprovedBy': x.userApproved,
            'ApprovedDate': x.approvedDate,
            'ProductType': x.productType == true ? 'Failed' : 'Replant',
            'CompanyNumber': x.companyNumber,
            'OriginalOrderNumber': x.orderNumber,
            'OriginalOrderType': x.orderType,
            'LineNumber': x.lineNumber,
            'ItemNumber': x.itemNumber,
            'Item': x.item,
            'SeedSize': x.seedSize,
            'LotNumber': x.lotNumber,
            'PricePerUnit': x.pricePerUnit,
            'Units': x.units,
            'UnitsFailed': x.unitsFailed,
            'Units Replant Credited': '',
            'InvoiceNumber': x.purchaseOrder,
            'ProductLine': x.productLine,
            'Request Date': this.datePipe.transform(x.requestDate, MasterConstants.DATE_MMDDYYYY),
            'OriginalInvoiceNumberToGrower': x.originalInvoiceNumberToGrower,
            'Plant Date': this.datePipe.transform(x.plantDate, MasterConstants.DATE_MMDDYYYY),
            'ProblemDescription': x.problemDescription,
            'Approver Notes': x.approverNotes
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'DraftsCropLossRequests');
        this.loaderService.setLoaderStatus(false);
      }

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  navigateApproveRequest(row) {
    this.seedCropLossService.isViewRequest = false;
    this.seedCropLossService.isApproverUser = true;
    this.seedCropLossService.setRequestHeaderId(row.requestId);
    this.router.navigate(['/crop-loss-approve']);
  }

  navigateViewRequest(row) {
    if (this.isApprovalAccess && row.isDSM) {
      this.navigateApproveRequest(row);
    } else {
      this.seedCropLossService.isApproverUser = false;
      this.seedCropLossService.isViewRequest = true;
      this.seedCropLossService.setRequestHeaderId(row.requestId);
      this.router.navigate(['/crop-loss-view-request']);
    }
  }

  viewOrderToInvoice(element) {
    this.loaderService.setLoaderStatus(true);
    if (element.jdeOrderNumber && element.jdeOrderType) {
      //this.localStorageService.set(MasterConstants.OTI_SALESORDERNUMBER, element.jdeOrderNumber);
      //this.router.navigate(['/cc/landing-data']);
      this.filters.salesOrderNumber = element.jdeOrderNumber;
      this.filters.dateInDays = 0;
      this.filters.fromOrderDate = element.draftDate !== null ? new Date(element.draftDate) : null;
      this.filters.toOrderDate = new Date();
      this.filters.orderStatus = null;
      this.filters.orderStatusText = "ALL";
      this.filters.productLineSegment = 'SEED';
      this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
        + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
      this.otiService.setFilters(this.filters);
      this.router.navigate(['/order/dashboard']);
    } else {
      this.toastrService.error('Order not found. Please check back.');
    }
    this.loaderService.setLoaderStatus(false);
  }

  emailOrderDetail(obj: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }

    this.tabNode = this.tabNode ? false : true;
    const dialogData = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: dialogData
    });
    emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          RequestHeaderId: obj.requestId,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);
        this.seedCropLossService.sendCropLossNewRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        });
      }
      this.tabNode = false;
    });
  }

  // Generate PDF
  generatedPdf(order: any) {
    if (order.requestId) {
      this.seedCropLossService.generatePdf(order.requestId);
    }
  }

  // checkAndSetShowCreateNewRequestByConfigData() {
  //  let currentDate = new Date();
  //  this.isShowCreateNewRequestByConfigData = true;

  //  for (let productConfigData of this.effectiveConfigData) {
  //    if (new Date(productConfigData.retailerEntryEffectiveFromDate) > currentDate || new Date(productConfigData.retailerEntryEffectiveToDate) < currentDate) {
  //      this.isShowCreateNewRequestByConfigData = false;
  //      break;
  //    }
  //  }
  // }
}
